import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import Dentists from "@/pages/dentists/page";
import PatientInfo from "@/pages/patient-info/page";
import Process from "@/pages/process/page";
import Why from "@/pages/why/page";
import Faq from "@/pages/faq/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkimizda",
    element: <About />,
  },
  {
    path: "/hizmetler",
    element: <Services />,
  },
  {
    path: "/dis-hekimleri",
    element: <Dentists />,
  },
  {
    path: "/hasta-bilgilendirme",
    element: <PatientInfo />,
  },
  {
    path: "/surec",
    element: <Process />,
  },
  {
    path: "/neden-dmar",
    element: <Why />,
  },
  {
    path: "/sss",
    element: <Faq />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;